import { render, staticRenderFns } from "./OnboardingStep4.vue?vue&type=template&id=5fe5e039&scoped=true&"
import script from "./OnboardingStep4.vue?vue&type=script&lang=js&"
export * from "./OnboardingStep4.vue?vue&type=script&lang=js&"
import style0 from "./OnboardingStep4.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./OnboardingStep4.vue?vue&type=style&index=1&id=5fe5e039&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fe5e039",
  null
  
)

export default component.exports